import Layout from '@/AppMain.vue';

const orders= {
    path: '/orders',
    name: 'Zamówienia',
    component: Layout,
    children:[
        {
            path: '/orders',
            name: 'Zamówienia',
            component: () => import('@/views/orders/browse'),
            meta: {title: 'Orders', auth: true, name:'Orders', back:'/', user_permission:'browse_orders', middlewares:['activeWebsite'], breadcrumbs: [{title: 'Dashboard', to: '/'}]}
        },
        {
            path: '/orders/:hash',
            name: 'Zamówienie nr :hash',
            component: () => import('@/views/orders/single'),
            meta: {title: 'Order', auth: true, name:'Orders', back:'/orders', user_permission:'browse_single_order', middlewares:['activeWebsite'], breadcrumbs: [{title: 'Dashboard', to: '/'}, {title:"Orders", to:'/orders'}]}
        },
        {
            path: '/all/orders',
            name: 'All orders',
            component: () => import('@/views/orders/all'),
            meta: {title: 'All orders', auth: true, name:'All orders', back:'/orders', user_permission:'browse_single_order', middlewares:['activeWebsite'], breadcrumbs: [{title: 'Dashboard', to: '/'}]}
        }
    ]
};
export default orders;
